import {FormControl, FormField} from 'platform/components';
import {Grid, GridItem, Show} from 'platform/foundation';

import {useWatch} from 'react-hook-form';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {useCashRegister} from '@dms/shared';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../../../types/WarehouseDirectSaleVariantsDetailFormSchema';

export type AutoInitiatePaymentPath = 'cashPayment' | 'cardPayment' | 'internalPayment';

export interface AutoInitiatePaymentProps extends TestIdProps {
  control: FormControl<WarehouseDirectSaleVariantsDetailFormSchemaType>;
  path: AutoInitiatePaymentPath | Nullish;
  isDisabled?: boolean;
}

export function AutoInitiatePayment(props: AutoInitiatePaymentProps) {
  // The cash register belongs to the cash payment only, so its visibility follows the cash card's
  // own flag no matter which card renders this component.
  const isCashAutoInitiatePayment = useWatch({
    control: props.control,
    name: 'documents.cashPayment.isAutoInitiatePayment',
  });
  const {cashRegisterOptions, isLoading: isCashRegisterLoading} = useCashRegister();

  if (isNil(props.path)) {
    return null;
  }

  return (
    <Grid columns={2}>
      <GridItem span={1}>
        <FormField
          control={props.control}
          name={`documents.${props.path}.isAutoInitiatePayment`}
          type="checkbox"
          label={i18n.t('entity.settings.labels.initiatePaymentAutomatically')}
          helperText={i18n.t('entity.settings.labels.initiatePaymentAutomaticallyHelper')}
          isDisabled={props.isDisabled}
          data-testid={suffixTestId('initiatePaymentAutomatically', props)}
        />
      </GridItem>
      <GridItem span={1}>
        <Show when={props.path === 'cashPayment' && isCashAutoInitiatePayment}>
          <FormField
            control={props.control}
            name="documents.cashPayment.cashRegisterId"
            type="choice"
            label={i18n.t('general.labels.cashRegister')}
            options={cashRegisterOptions}
            isLoading={isCashRegisterLoading}
            isRequired
            data-testid={suffixTestId('cashRegister', props)}
          />
        </Show>
      </GridItem>
    </Grid>
  );
}
